export const formatChartTheme = (theme: string): string[] => {
  return theme.split(',');
};
